import { downloadName } from "./meet-gary-catalog";

export const zipEntries = (catalog, region) =>
    catalog.storiesFor(region).map((story) => ({
        name: downloadName(story, region),
        href: catalog.fileFor(story.id, region).href,
    }));

export const regionZipName = (region) => `HSA Tax Savings – ${region}.zip`;

const fetchPdf = async (href, fetchImpl) => {
    const response = await fetchImpl(href);
    const type = response.headers.get("content-type") || "";
    if (!response.ok || !type.includes("pdf")) {
        throw new Error(`Not a PDF: ${href}`);
    }
    return new Uint8Array(await response.arrayBuffer());
};

export const buildRegionZip = async (entries, fetchImpl = window.fetch.bind(window)) => {
    const [{ zipSync }, contents] = await Promise.all([
        import("fflate"),
        Promise.all(entries.map((e) => fetchPdf(e.href, fetchImpl))),
    ]);
    const files = Object.fromEntries(entries.map((e, i) => [e.name, contents[i]]));
    return zipSync(files, { level: 0 });
};
